module.exports = __webpack_public_path__ + "static/media/dark_dataak_headlogo.15599296.svg";